import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastComponent, ToastData } from '@ui';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private snackBar: MatSnackBar) {}

  private open(data: ToastData) {
    this.snackBar.openFromComponent(ToastComponent, {
      data,
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['custom-snackbar'],
    });
  }

  success(message: string) {
    this.open({ message, type: 'success' });
  }

  error(message: string) {
    this.open({
      message,
      type: 'error',
    });
  }

  warning(message: string) {
    this.open({
      message,
      type: 'warning',
    });
  }

  info(message: string) {
    this.open({
      message,
      type: 'info',
    });
  }

  show(data: ToastData) {
    this.open(data);
  }
}
